import { z } from 'zod';

const id = z.string().min(1).max(256).refine(value => !/[\/\u0000-\u001f\u007f]/.test(value) && !value.includes(String.fromCharCode(92)) && value !== '.' && value !== '..');
const digest = z.string().regex(/^[0-9a-f]{64}$/);
export const cseReportReviewBasisSchema = z.object({
  schemaVersion: z.literal('report-cse-review-basis-v1'),
  ownerUid: id, reportId: id, siteId: id.nullable(),
  reportRevisionId: id.nullable(), sedId: id.nullable(),
  sedVersionUsed: z.number().int().positive().nullable(),
  reportStoragePath: z.string().min(1).max(2048),
  metadataHash: digest, bodyHash: digest, conflictsHash: digest,
}).strict();
export const cseReportConflictSchema = z.object({
  reportSectionId: z.string().min(1).max(256), field: z.string().min(1).max(256),
  values: z.array(z.string().min(1).max(4096)).min(2).max(32).refine(values => new Set(values).size === values.length, 'Duplicate conflict value'),
}).strict();
export const cseReviewChoicesSchema = z.array(z.object({
  conflictKey: z.string().min(1).max(520), value: z.string().min(1).max(4096),
}).strict()).min(1).max(128).refine(rows => new Set(rows.map(row => row.conflictKey)).size === rows.length, 'Duplicate conflict key');
export const saveCseReportReviewRequestSchema = z.object({
  operationId: z.string().uuid(), basis: cseReportReviewBasisSchema, choices: cseReviewChoicesSchema,
}).strict();
export const cseReportReviewRecordSchema = saveCseReportReviewRequestSchema.extend({
  schemaVersion: z.literal('report-cse-review-v1'), reviewedAt: z.string().datetime(), reviewedByUid: id,
}).strict();
export const cseReportReviewContextSchema = z.object({
  basis: cseReportReviewBasisSchema,
  conflicts: z.array(cseReportConflictSchema).min(1).max(128),
  review: cseReportReviewRecordSchema.nullable(),
  sedSyncStatus: z.literal('pending-publication'),
}).strict();
export const cseReportReviewAckSchema = z.object({
  saved: z.literal(true), review: cseReportReviewRecordSchema,
  sedSyncStatus: z.literal('pending-publication'),
}).strict();
export type CseReportReviewBasis = z.infer<typeof cseReportReviewBasisSchema>;
export type CseReportConflict = z.infer<typeof cseReportConflictSchema>;
export type SaveCseReportReviewRequest = z.infer<typeof saveCseReportReviewRequestSchema>;
export type CseReportReviewRecord = z.infer<typeof cseReportReviewRecordSchema>;
export type CseReportReviewContext = z.infer<typeof cseReportReviewContextSchema>;
export type CseReportReviewAck = z.infer<typeof cseReportReviewAckSchema>;
